import { all, call } from "redux-saga/effects";
import { userSaga } from "./userredux/user_saga";
export default function* rootsaga() {
  yield all([call(userSaga)]);
}
